<mat-dialog-content>
    <div class="modal-header d-flex align-items-center justify-content-end" *ngIf="!hideCloseIcon">
         <button type="button" #closebutton class="close btn-close"
          [mat-dialog-close]="false" data-dismiss="modal"> <i
            class="fa-solid fa-xmark"></i></button> 
      </div>
    <div class="verification-modal">
        <!-- <mat-icon class="verified-icon" [ngClass]="fontIcon === 'check_circle_outlined' ? 'text-primay' : 'text-danger'" aria-hidden="false" aria-label="Example home icon" [fontIcon]="fontIcon"></mat-icon> -->
<!-- 
        @if(fontIcon === 'check_circle_outlined'){
          <h3>{{title}}</h3>
        }@else if(fontIcon == "report_gmailerrorred"){
          <h3 class="text-danger">{{title}}</h3>
          <p>4 Attempts,<span class="text-danger">Failed!</span></p>
        }@else { -->
          <h3 class="text-primary">{{title | translate}}</h3> 
        <!-- } -->
        <h4>{{Description1 | translate }} {{ leadNumber }} {{Description2 | translate }}</h4>
        <button mat-flat-button color="primary" class="my-3 px-5" (click)="close()">{{btnText}}</button>
    </div>
</mat-dialog-content>
  

